import { useTranslation } from '@kb/i18n';
import eventBus, { EventTypes } from '@ocp/event-bus';
import { useMutation } from '@ocp/graphql-client';
import { notifyDanger } from '@ocp/notifications';
import i18nKeys from '../i18n/index';
export const ADD_TO_FAVORITE_CONTENT_MUTATION = `
  mutation createFavoriteContent($classNameId: Long, $classPk: Long) {
    createFavoriteContent(classNameId: $classNameId, classPk: $classPk)
  }
`;
const useAddToFavoriteContentMutation = (classNameId, classPk) => {
    const { t } = useTranslation();
    return useMutation(ADD_TO_FAVORITE_CONTENT_MUTATION, {
        variables: { classNameId, classPk },
        onCompleted: () => {
            eventBus.fire(EventTypes.ToggleFavorite, {
                data: {
                    classNameId,
                    classPk,
                    favorite: true,
                },
            });
        },
        onError: (e) => {
            console.error(e);
            notifyDanger(t(i18nKeys.ERROR_IS_OCCURED));
        },
    });
};
export default useAddToFavoriteContentMutation;
